import { CONTROL_CENTRE_API_DOMAIN } from '@/config/constants'
import useAuthenticatedQuery from '@/hooks/useAuthenticatedQuery'
import { QUERY_KEYS } from '../utils/queryKeys'
import type {
  AdminApplicationItem,
  PaginatedResponse,
} from '@/types/controlCenter'

const useAdminApplications = () => {
  const { data, isLoading, error } = useAuthenticatedQuery<
    PaginatedResponse<AdminApplicationItem>
  >(QUERY_KEYS.applications, `${CONTROL_CENTRE_API_DOMAIN}/admin/applications`)

  return { applications: data?.data ?? [], isLoading, error }
}

export default useAdminApplications
